import styled from 'styled-components'
import { LinkButton } from '@/components/common/buttons'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { Typo } from '@/components/common/typography'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import { Z_INDEXES } from '@/constants/legacy/constLayout'

export const OrderPageHeader = () => {
  return (
    <StyledHeader>
      <div className="back-button">
        <LinkButton goBack>
          <FlatIcon type={IconNameEnum.IcBack} size={IconSizeEnum.Size24} />
        </LinkButton>
      </div>
      <div className="title">
        <Typo variant={'Body1 Bold'} as={'h1'}>
          결제
        </Typo>
      </div>
    </StyledHeader>
  )
}

const StyledHeader = styled.div`
  height: 6rem;
  z-index: ${Z_INDEXES.HEADER};
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  box-sizing: border-box;
  width: 100%;
  max-width: 576px;
  background-color: ${({
    theme: {
      color: { grayWhite },
    },
  }) => grayWhite};
  transition: transform 0.2s;
  -webkit-transition: transform 0.2s;

  display: flex;
  align-items: center;
  padding: 0 1.6rem;

  border-bottom: 1px solid rgb(244, 247, 250);

  .back-button {
    position: absolute;
  }

  .title {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`
